var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:(_vm.$vuetify.breakpoint.smAndUp && _vm.oldVersion === null) ? 'scroll-container' : ''},[_c('div',{staticClass:"ma-2"},[_c('v-expansion-panels',_vm._l((_vm.patchnote),function(note,version){return _c('patchnote-content',{key:version,attrs:{"version":version,"day":note.day,"content":note.content}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }